import { recordSentry } from "utils/recordSentry";
import { db } from "../db";
import { AutoSyncConfig } from "db/definitions";

/**
 * Get all the auto sync configs from the offline db.
 * @returns list of auto sync configs.
 */
export async function getAllAutoSyncConfigs(): Promise<AutoSyncConfig[]> {
	// get all the auto sync configs
	try {
		const autoSyncConfigs = await db.autoSyncConfig.toArray();
		return autoSyncConfigs;
	} catch (error) {
		recordSentry({ error, msg: "Error retrieving autoSyncConfigs:", showModal: true });
	}
	return [];
}

export async function bulkDeleteAutoSyncConfigs(ids: string[]): Promise<void> {
	try {
		await db.autoSyncConfig.bulkDelete(ids);
	} catch (error) {
		recordSentry({ error, msg: "ERROR DELETING AUTO SYNC CONFIGS" });
	}
}

export async function bulkSaveAutoSyncConfigs(autoSyncConfigs: AutoSyncConfig[]): Promise<void> {
	try {
		await db.autoSyncConfig.bulkPut(autoSyncConfigs);
	} catch (error) {
		recordSentry({ error, msg: "ERROR SAVING AUTO SYNC CONFIGS", showModal: true });
	}
}
